// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uip-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}
.uip-logo {
  font-family: 'Playfair Display', serif;
  font-size: 1.3rem;
  color: var(--burgundy);
  cursor: pointer;
  flex: 1 1;
}
.logout-icon-btn {
  background: none;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 6px 10px;
  color: var(--burgundy);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.logout-icon-btn:hover { background: var(--burgundy); color: #fff; }

.uip-body {
  max-width: 640px;
  margin: 0 auto;
  padding: 24px 16px 60px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.uip-avatar-section {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, var(--burgundy), var(--purple));
  border-radius: 16px;
  color: #fff;
}
.uip-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 700;
  color: #fff;
  border: 2px solid rgba(255,255,255,0.4);
}
.uip-display-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  margin: 0 0 2px;
}
.uip-username { margin: 0; font-size: 0.85rem; opacity: 0.8; }

.uip-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px;
}
.uip-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.uip-card-header h3 {
  font-family: 'Playfair Display', serif;
  font-size: 1rem;
  color: var(--burgundy);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.edit-btn {
  background: none;
  border: 1px solid var(--burgundy);
  color: var(--burgundy);
  border-radius: 8px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
}
.edit-btn:hover { background: var(--burgundy); color: #fff; }
.edit-actions { display: flex; gap: 8px; }
.save-btn {
  background: var(--burgundy);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cancel-btn {
  background: none;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.uip-fields { display: flex; flex-direction: column; gap: 12px; }
.uip-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.uip-field label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.uip-field span {
  font-size: 0.95rem;
  color: var(--text-primary);
  font-weight: 500;
}
.uip-field input {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.9rem;
  outline: none;
  background: var(--bg);
  color: var(--text-primary);
  transition: border 0.2s;
}
.uip-field input:focus { border-color: var(--burgundy); }

/* Addresses */
.addr-add-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding: 12px;
  background: var(--bg);
  border-radius: 10px;
  border: 1px dashed var(--border);
}
.addr-add-form textarea, .addr-add-form input {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.9rem;
  background: var(--bg-card);
  color: var(--text-primary);
  resize: none;
  outline: none;
}
.addr-add-form textarea:focus, .addr-add-form input:focus { border-color: var(--burgundy); }
.addr-form-actions { display: flex; gap: 8px; }
.no-addr { color: var(--text-muted); font-size: 0.9rem; text-align: center; padding: 12px 0; }

.addr-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}
.addr-item:last-child { border-bottom: none; }
.addr-text { flex: 1 1; }
.addr-text p { margin: 0 0 2px; font-size: 0.9rem; }
.addr-pin { color: var(--text-muted); font-size: 0.8rem !important; }
.addr-del {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
}
.addr-del:hover { color: #B71C1C; background: rgba(183,28,28,0.08); }

/* Quick links */
.uip-links { display: flex; flex-direction: column; gap: 0; padding: 0; }
.uip-links button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  color: var(--text-primary);
  font-size: 0.9rem;
  text-align: left;
  transition: background 0.15s;
}
.uip-links button:last-child { border-bottom: none; }
.uip-links button:hover { background: var(--bg); }

.full-logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  background: none;
  border: 2px solid #B71C1C;
  border-radius: 12px;
  color: #B71C1C;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.full-logout-btn:hover { background: #B71C1C; color: #fff; }
`, "",{"version":3,"sources":["webpack://./src/components/pages/UserInfoPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,yBAAyB,2BAA2B,EAAE,WAAW,EAAE;;AAEnE;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mEAAmE;EACnE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;AACjB;AACA,gBAAgB,SAAS,EAAE,kBAAkB,EAAE,YAAY,EAAE;;AAE7D;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,kBAAkB,2BAA2B,EAAE,WAAW,EAAE;AAC5D,gBAAgB,aAAa,EAAE,QAAQ,EAAE;AACzC;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,cAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA,yBAAyB,6BAA6B,EAAE;;AAExD,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;AACf;AACA,4DAA4D,6BAA6B,EAAE;AAC3F,qBAAqB,aAAa,EAAE,QAAQ,EAAE;AAC9C,WAAW,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAE7F;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,aAAa,SAAO,EAAE;AACtB,eAAe,eAAe,EAAE,iBAAiB,EAAE;AACnD,YAAY,wBAAwB,EAAE,4BAA4B,EAAE;AACpE;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA,kBAAkB,cAAc,EAAE,gCAAgC,EAAE;;AAEpE,gBAAgB;AAChB,aAAa,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE,UAAU,EAAE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,+BAA+B,mBAAmB,EAAE;AACpD,0BAA0B,qBAAqB,EAAE;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA,yBAAyB,mBAAmB,EAAE,WAAW,EAAE","sourcesContent":[".uip-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n.uip-logo {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.3rem;\n  color: var(--burgundy);\n  cursor: pointer;\n  flex: 1;\n}\n.logout-icon-btn {\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 6px 10px;\n  color: var(--burgundy);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.logout-icon-btn:hover { background: var(--burgundy); color: #fff; }\n\n.uip-body {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 24px 16px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.uip-avatar-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  background: linear-gradient(135deg, var(--burgundy), var(--purple));\n  border-radius: 16px;\n  color: #fff;\n}\n.uip-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #fff;\n  border: 2px solid rgba(255,255,255,0.4);\n}\n.uip-display-name {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.2rem;\n  margin: 0 0 2px;\n}\n.uip-username { margin: 0; font-size: 0.85rem; opacity: 0.8; }\n\n.uip-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 18px;\n}\n.uip-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.uip-card-header h3 {\n  font-family: 'Playfair Display', serif;\n  font-size: 1rem;\n  color: var(--burgundy);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.edit-btn {\n  background: none;\n  border: 1px solid var(--burgundy);\n  color: var(--burgundy);\n  border-radius: 8px;\n  padding: 4px 10px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.edit-btn:hover { background: var(--burgundy); color: #fff; }\n.edit-actions { display: flex; gap: 8px; }\n.save-btn {\n  background: var(--burgundy);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 4px 12px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.cancel-btn {\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 4px 10px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.uip-fields { display: flex; flex-direction: column; gap: 12px; }\n.uip-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.uip-field label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.uip-field span {\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.uip-field input {\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  outline: none;\n  background: var(--bg);\n  color: var(--text-primary);\n  transition: border 0.2s;\n}\n.uip-field input:focus { border-color: var(--burgundy); }\n\n/* Addresses */\n.addr-add-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 12px;\n  background: var(--bg);\n  border-radius: 10px;\n  border: 1px dashed var(--border);\n}\n.addr-add-form textarea, .addr-add-form input {\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  background: var(--bg-card);\n  color: var(--text-primary);\n  resize: none;\n  outline: none;\n}\n.addr-add-form textarea:focus, .addr-add-form input:focus { border-color: var(--burgundy); }\n.addr-form-actions { display: flex; gap: 8px; }\n.no-addr { color: var(--text-muted); font-size: 0.9rem; text-align: center; padding: 12px 0; }\n\n.addr-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n.addr-item:last-child { border-bottom: none; }\n.addr-text { flex: 1; }\n.addr-text p { margin: 0 0 2px; font-size: 0.9rem; }\n.addr-pin { color: var(--text-muted); font-size: 0.8rem !important; }\n.addr-del {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n}\n.addr-del:hover { color: #B71C1C; background: rgba(183,28,28,0.08); }\n\n/* Quick links */\n.uip-links { display: flex; flex-direction: column; gap: 0; padding: 0; }\n.uip-links button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid var(--border);\n  cursor: pointer;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  text-align: left;\n  transition: background 0.15s;\n}\n.uip-links button:last-child { border-bottom: none; }\n.uip-links button:hover { background: var(--bg); }\n\n.full-logout-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px;\n  background: none;\n  border: 2px solid #B71C1C;\n  border-radius: 12px;\n  color: #B71C1C;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.full-logout-btn:hover { background: #B71C1C; color: #fff; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
